module.exports = __webpack_public_path__ + "static/media/align-right.6f471b6e.svg";